<template>
  <div class="site-wrapper">
    <nav class="navbar navbar-expand-lg fixed-top" :class="{ scrolled: isScrolled }">
      <div class="container">
        <router-link to="/" class="navbar-brand">Chris Roughsedge</router-link>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#mainNav"
          aria-controls="mainNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="toggler-bar"></span>
          <span class="toggler-bar"></span>
          <span class="toggler-bar"></span>
        </button>
        <div class="collapse navbar-collapse" id="mainNav">
          <ul class="navbar-nav ms-auto">
            <li class="nav-item">
              <router-link to="/" class="nav-link" exact-active-class="active">Home</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/about" class="nav-link" active-class="active">About</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/services" class="nav-link" active-class="active">Services</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/portfolio" class="nav-link" active-class="active">Portfolio</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/contact" class="nav-link btn-nav" active-class="active">Contact</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <main>
      <router-view />
    </main>

    <footer class="site-footer">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-4">
            <div class="footer-brand">Chris Roughsedge</div>
            <p class="footer-tagline">Football Tactics & Analysis</p>
          </div>
          <div class="col-md-4 text-center">
            <a href="mailto:chris@thematchanalyst.co.uk" class="footer-email">chris@thematchanalyst.co.uk</a>
          </div>
          <div class="col-md-4 text-md-end">
            <p class="footer-copy">&copy; {{ currentYear }} Chris Roughsedge. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'SiteNavigation',
  data() {
    return {
      isScrolled: false,
      currentYear: new Date().getFullYear()
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50
    }
  }
}
</script>

<style scoped>
.site-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1;
}

/* Navbar */
.navbar {
  padding: 1.25rem 0;
  transition: all 0.3s ease;
  background: transparent;
}

.navbar.scrolled {
  background: rgba(6, 14, 26, 0.95);
  backdrop-filter: blur(10px);
  padding: 0.75rem 0;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
}

.navbar-brand {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1.35rem;
  color: var(--white) !important;
  letter-spacing: 0.5px;
}

.nav-link {
  color: var(--silver-light) !important;
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: 0.75px;
  text-transform: uppercase;
  padding: 0.5rem 1.25rem !important;
  transition: color 0.2s ease;
}

.nav-link:hover,
.nav-link.active {
  color: var(--white) !important;
}

.btn-nav {
  border: 1.5px solid var(--silver) !important;
  border-radius: 4px !important;
  margin-left: 0.5rem;
  padding: 0.4rem 1.25rem !important;
}

.btn-nav:hover {
  border-color: var(--white) !important;
}

.navbar-toggler {
  border: none;
  padding: 0.5rem;
}

.navbar-toggler:focus {
  box-shadow: none;
}

.toggler-bar {
  display: block;
  width: 24px;
  height: 2px;
  background: var(--white);
  margin: 5px 0;
  transition: 0.3s;
}

/* Footer */
.site-footer {
  background: var(--navy-dark);
  border-top: 1px solid var(--border-subtle);
  padding: 3rem 0;
}

.footer-brand {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1.1rem;
  color: var(--white);
}

.footer-tagline {
  color: var(--silver);
  font-size: 0.85rem;
  margin-top: 0.25rem;
  margin-bottom: 0;
}

.footer-email {
  color: var(--silver);
  font-size: 0.9rem;
  transition: color 0.2s ease;
}

.footer-email:hover {
  color: var(--white);
}

.footer-copy {
  color: var(--silver);
  font-size: 0.8rem;
  margin-bottom: 0;
}

@media (max-width: 768px) {
  .site-footer .row > div {
    text-align: center !important;
    margin-bottom: 1.5rem;
  }

  .site-footer .row > div:last-child {
    margin-bottom: 0;
  }

  .navbar-collapse {
    background: rgba(6, 14, 26, 0.98);
    padding: 1rem;
    margin-top: 0.5rem;
    border-radius: 8px;
  }

  .btn-nav {
    margin-left: 0 !important;
    display: inline-block;
    margin-top: 0.5rem;
  }
}
</style>
